/* Gullye — product-card quick add engine.
   The + on a card adds via /cart/add.js (AJAX), opens the cart drawer (tray),
   updates the count bubble, bumps the icon, fires the cart-update event (so
   Klaviyo + GA4 log it), then swaps the + into a "- N +" stepper wired to
   /cart/change.js. Runs on any page that shows product cards. */
(function () {
  var routes = window.routes || {};
  var ADD_URL = routes.cart_add_url || '/cart/add';
  var CHANGE_URL = routes.cart_change_url || '/cart/change';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function drawerEl() { return document.querySelector('cart-drawer'); }

  function bump() {
    var c = document.getElementById('cart-icon-bubble');
    if (!c) return;
    c.classList.remove('gy-cart-bump');
    void c.offsetWidth;
    c.classList.add('gy-cart-bump');
    setTimeout(function () { c.classList.remove('gy-cart-bump'); }, 600);
  }

  // Update the drawer + count bubble from a response's `sections`, without
  // opening the drawer (used for stepper +/- once the item is already in cart).
  function applySections(state) {
    if (!state || !state.sections) return;
    [['cart-drawer', '#CartDrawer'], ['cart-icon-bubble', '#cart-icon-bubble']].forEach(function (pair) {
      var html = state.sections[pair[0]];
      if (!html) return;
      var target = document.querySelector(pair[1]);
      if (!target) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(pair[1]);
      if (parsed) target.innerHTML = parsed.innerHTML;
    });
  }

  function fireCartUpdate(itemResp) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: itemResp });
      }
    } catch (e) {}
  }

  function stepper(variantId, qty, title) {
    var s = document.createElement('div');
    s.className = 'gy-qk gy-qk-step';
    s.setAttribute('data-gy-step', '');
    s.setAttribute('data-variant-id', variantId);
    if (title) s.setAttribute('data-title', title);
    s.innerHTML =
      '<button type="button" class="gy-qk-step__b" data-gy-dec aria-label="Remove one">−</button>' +
      '<span class="gy-qk-step__n" aria-live="polite">' + qty + '</span>' +
      '<button type="button" class="gy-qk-step__b" data-gy-inc aria-label="Add one">+</button>';
    return s;
  }

  function addButton(variantId, title) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'gy-qk gy-qk--add';
    b.setAttribute('data-gy-add', '');
    b.setAttribute('data-variant-id', variantId);
    if (title) b.setAttribute('aria-label', 'Add ' + title + ' to bag');
    b.innerHTML = '<svg class="gy-qk__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg><span class="gy-qk__spin" aria-hidden="true"></span>';
    return b;
  }

  function flash(el) { el.classList.add('gy-qk--err'); setTimeout(function () { el.classList.remove('gy-qk--err'); }, 550); }

  function doAdd(btn) {
    if (btn.classList.contains('is-loading')) return;
    var variantId = btn.getAttribute('data-variant-id');
    var title = btn.getAttribute('data-title') || (btn.getAttribute('aria-label') || '').replace(/^Add /, '').replace(/ to bag$/, '');
    if (!variantId) return;
    btn.classList.add('is-loading');
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    body.append('sections', SECTIONS);
    body.append('sections_url', window.location.pathname);
    fetch(ADD_URL, { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok) { flash(btn); return; }
        var d = drawerEl();
        if (d && res.data.sections) { d.classList.remove('is-empty'); d.renderContents(res.data); }
        else { applySections(res.data); }
        fireCartUpdate(res.data);
        bump();
        // Shopify's native add_to_cart is page-scoped: on a listing page it says
        // an add happened, not which card produced it. This carries the product,
        // so the PLP table can attribute adds per product.
        try {
          var qaCard = btn.closest('[data-gy-card]');
          if (window.gyTrack) {
            var qm = window.location.pathname.match(/\/collections\/([^/?#]+)/);
            window.gyTrack('plp_quick_add', {
              product_id: qaCard ? (qaCard.getAttribute('data-gy-item-id') || '') : '',
              product_name: (qaCard && qaCard.getAttribute('data-gy-item-name')) || title || '',
              collection_handle: qm ? qm[1] : '',
              variant_id: String(variantId)
            });
          }
        } catch (e) {}
        var qty = res.data.quantity || 1;
        btn.replaceWith(stepper(variantId, qty, title));
      })
      .catch(function () { btn.classList.remove('is-loading'); flash(btn); });
  }

  function setQty(step, qty) {
    if (step.classList.contains('is-loading')) return;
    var variantId = step.getAttribute('data-variant-id');
    var title = step.getAttribute('data-title');
    step.classList.add('is-loading');
    fetch(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(variantId), quantity: qty, sections: SECTIONS, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        step.classList.remove('is-loading');
        applySections(cart);
        bump();
        if (qty <= 0) {
          step.replaceWith(addButton(variantId, title));
        } else {
          var n = step.querySelector('.gy-qk-step__n');
          if (n) n.textContent = qty;
        }
      })
      .catch(function () { step.classList.remove('is-loading'); });
  }

  // Capture phase + stopPropagation so the card's whole-card link never fires.
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-gy-add]');
    if (add) { e.preventDefault(); e.stopPropagation(); doAdd(add); return; }
    var inc = e.target.closest('[data-gy-inc]');
    if (inc) {
      e.preventDefault(); e.stopPropagation();
      var s = inc.closest('[data-gy-step]');
      setQty(s, (parseInt(s.querySelector('.gy-qk-step__n').textContent, 10) || 0) + 1);
      return;
    }
    var dec = e.target.closest('[data-gy-dec]');
    if (dec) {
      e.preventDefault(); e.stopPropagation();
      var s2 = dec.closest('[data-gy-step]');
      setQty(s2, (parseInt(s2.querySelector('.gy-qk-step__n').textContent, 10) || 0) - 1);
      return;
    }
  }, true);

  // On load, reflect items already in the cart as steppers (so + doesn't stack
  // on top of an unseen quantity).
  function initFromCart() {
    var adds = document.querySelectorAll('[data-gy-add]');
    if (!adds.length) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var map = {};
        cart.items.forEach(function (it) { map[String(it.variant_id)] = it.quantity; });
        adds.forEach(function (btn) {
          var q = map[btn.getAttribute('data-variant-id')];
          if (q) btn.replaceWith(stepper(btn.getAttribute('data-variant-id'), q, btn.getAttribute('data-title')));
        });
      }).catch(function () {});
  }
  if (document.readyState !== 'loading') initFromCart();
  else document.addEventListener('DOMContentLoaded', initFromCart);
})();

/* ── Card image scroller — "drift + dissolve" gallery ──
   Slides are stacked (absolute); changing image crossfades the outgoing/incoming
   images while the incoming one glides a few % in the travel direction. Arrows on
   desktop (hover), swipe/drag on touch + mouse. Secondary images are deferred
   (data-src) and hydrated on first interaction, so a PLP loads one image per card.
   Honours prefers-reduced-motion (instant swap). */
(function () {
  var SWIPE = 40;              // px drag threshold

  // ── card engagement telemetry ──
  // A flip means the shopper wanted another angle before committing to a click —
  // the strongest interest signal a listing page produces. Reported ONCE per card
  // per pageview: one shopper flipping five times is one interested shopper, and
  // counting each swipe would let a single fidget outrank five separate people.
  function gyCardMeta(root) {
    var card = root.closest && root.closest('[data-gy-card]');
    if (!card) return null;
    var m = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return {
      product_id: card.getAttribute('data-gy-item-id') || '',
      product_name: card.getAttribute('data-gy-item-name') || '',
      collection_handle: m ? m[1] : ''
    };
  }
  function gyReportFlip(root, index) {
    if (root.__gyFlipped) return;
    root.__gyFlipped = true;
    var meta = gyCardMeta(root);
    if (!meta || !window.gyTrack) return;
    meta.image_index = index;
    window.gyTrack('plp_card_image_flip', meta);
  }

  // Scroll-snap card gallery for the mobile PLP grid. The browser owns the
  // drag; we paint the rail from the scroll offset and close the loop at the
  // far end with a CLONE of the first frame: swiping forward off the last
  // image slides into the clone exactly like any other next-swipe (founder:
  // "N-1 -> N should be the same as N -> 1 without feeling any difference"),
  // and once the track settles on the clone we cut scrollLeft back to the
  // real first frame — pixel-identical, so the cut is invisible. The settle
  // wait is the PDP gallery's mechanism verbatim: setTimeout poll (NOT rAF —
  // rAF pauses when the page isn't painted), two stable frames, ~650ms
  // ceiling, abandoned the moment a new touch takes the track back.
  function wireSnapTrack(root, track, slides, n, hydrate) {
    var railHost = root.nextElementSibling;
    var fill = railHost && railHost.classList.contains('gy-cardrail')
      ? railHost.querySelector('.gy-cardrail__fill')
      : null;
    if (fill) fill.style.width = (100 / n) + '%';

    var clone = slides[0].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-gy-clone', '');
    track.appendChild(clone);

    var lastIdx = 0;
    function reportIfMoved() {
      if (!track.clientWidth) return;
      var idx = Math.round(track.scrollLeft / track.clientWidth);
      // The wrap clone counts as frame 0, not a new frame.
      if (idx >= n) idx = 0;
      if (idx !== lastIdx) { lastIdx = idx; gyReportFlip(root, idx); }
    }
    function paint() {
      if (!fill || !track.clientWidth) return;
      // A float straight from the scroll offset: the line travels with the
      // finger. On the clone it slides off the right edge (the rail clips
      // it), and the realign below brings it back in at zero.
      fill.style.transform =
        'translateX(' + ((track.scrollLeft / track.clientWidth) * 100) + '%)';
    }

    var jumpPending = false;
    function realign() {
      track.scrollTo({ left: 0, behavior: 'auto' });
      paint();
    }
    function whenSettledRealign() {
      var last = track.scrollLeft, stable = 0, ticks = 0;
      (function tick() {
        if (!jumpPending) return; // a new touch took the track back
        if (ticks++ > 40) { jumpPending = false; return realign(); }
        var now = track.scrollLeft;
        if (now === last) { stable++; } else { stable = 0; last = now; }
        if (stable >= 2) { jumpPending = false; return realign(); }
        setTimeout(tick, 16);
      })();
    }

    // The cut is only ever scheduled with no finger on the track: writing
    // scrollLeft during an active drag is exactly what read as jitter on the
    // PDP's first wrap build. While touching, the clone just sits there being
    // image one; the schedule happens on touchend or on momentum scroll.
    var touching = false;
    function maybeScheduleWrap() {
      if (!track.clientWidth || touching || jumpPending) return;
      // Max scroll from scrollWidth, NOT n * clientWidth: clientWidth is an
      // INTEGER while the real slide width is fractional (181.5px in a 375px
      // 2-up grid), so n * clientWidth overshoots the true end by more than
      // the tolerance and the wrap never fires. 3px tolerance covers the
      // sub-pixel remainder (an exact compare never fires).
      var max = track.scrollWidth - track.clientWidth;
      if (max > 0 && track.scrollLeft >= max - 3) {
        jumpPending = true;
        whenSettledRealign();
      }
    }

    track.addEventListener('scroll', function () {
      if (!track.clientWidth) return;
      paint();
      reportIfMoved();
      maybeScheduleWrap();
    }, { passive: true });

    // Secondary frames are data-src until first touch; hydrate before any
    // movement so a swipe never lands on an empty frame. A fresh touch also
    // cancels a pending wrap cut — the shopper has taken the track back.
    track.addEventListener('touchstart', function () {
      touching = true;
      hydrate();
      jumpPending = false;
    }, { passive: true });
    track.addEventListener('touchend', function () {
      touching = false;
      // The drag can end already resting exactly on the clone, with no
      // further scroll events to run the check — run it here too.
      maybeScheduleWrap();
    }, { passive: true });
    track.addEventListener('touchcancel', function () {
      touching = false;
    }, { passive: true });

    // Rotation leaves the track resting between frames; re-align.
    window.addEventListener('resize', function () {
      var w = track.clientWidth;
      if (!w) return;
      track.scrollLeft = Math.round(track.scrollLeft / w) * w;
      paint();
    });

    paint();
  }

  function wire(root) {
    var track = root.querySelector('[data-gy-cardimg-track]');
    if (!track) return;
    var prev = root.querySelector('[data-gy-cardimg-prev]');
    var next = root.querySelector('[data-gy-cardimg-next]');
    var ind = root.querySelectorAll('.gy-cardimg__ind i');
    var slides = [].slice.call(root.querySelectorAll('.gy-cardimg__slide'));
    var n = slides.length;
    if (n) slides[0].classList.add('is-cur');

    var hydrated = false;
    function hydrate() {
      if (hydrated) return;
      hydrated = true;
      root.querySelectorAll('img.gy-cardimg__lazy').forEach(function (img) {
        if (img.dataset.src) img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.classList.remove('gy-cardimg__lazy');
      });
    }

    var cur = 0;
    function paint(i) {
      for (var j = 0; j < ind.length; j++) ind[j].classList.toggle('on', j === i);
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
    }

    // Pure dissolve: CSS owns the crossfade (opacity transition on .gy-cardimg__slide;
    // exactly one slide carries .is-cur). go() just moves .is-cur — no busy lock, so
    // rapid swipes/clicks interrupt smoothly and never have to "wait" for the previous
    // fade to finish. prefers-reduced-motion drops the transition in CSS.
    function go(to) {
      to = Math.max(0, Math.min(n - 1, to));
      if (to === cur) return;
      hydrate();
      slides[cur].classList.remove('is-cur');
      slides[to].classList.add('is-cur');
      cur = to;
      paint(cur);
      gyReportFlip(root, to);
    }

    // hydrate the moment the shopper engages the card
    root.addEventListener('pointerenter', hydrate, { once: true });
    root.addEventListener('touchstart', hydrate, { once: true, passive: true });

    // ── PLP-grid swipe mode ──
    // Native scroll-snap track (the PDP gallery's gesture), activated ONLY
    // where a grid opts in via data-gy-swipecards (gy-collection's mobile
    // PLP grids). Every other surface falls through to the stacked dissolve
    // below. The carousel check comes FIRST and wins: a card inside a
    // horizontal carousel never gets its own scroll track, whatever container
    // attributes sit above it (the RV rail renders inside gy-collection).
    var inCarouselEarly = !!(root.closest && root.closest('.gy-prail, .gy-rv, [data-gy-carousel]'));
    var inSwipeGrid = !inCarouselEarly &&
      !!(root.closest && root.closest('[data-gy-swipecards]')) &&
      window.matchMedia('(max-width: 749px)').matches;
    if (inSwipeGrid) {
      if (n > 1) wireSnapTrack(root, track, slides, n, hydrate);
      root.setAttribute('data-gy-cardimg-ready', '');
      return;
    }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(cur - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(cur + 1); });

    // House rule: a card sitting inside a horizontal carousel gives the sideways
    // swipe back to the carousel on touch, so the two gestures stop competing
    // (gy-cards.css restores touch-action there to match). Desktop keeps the
    // arrows, and cards in a static grid keep swipe-to-change-image.
    var inCarousel = !!(root.closest && root.closest('.gy-prail, .gy-rv, [data-gy-carousel]'));
    var noHover = window.matchMedia && window.matchMedia('(hover: none)').matches;
    if (inCarousel && noHover) { root.setAttribute('data-gy-cardimg-ready', ''); return; }

    // swipe / drag (touch + mouse). Ignore drags that begin on a control.
    // .gy-cardimg__track has touch-action:pan-y so horizontal touch swipes reach
    // these pointer handlers instead of being consumed as a page gesture.
    var sx = 0, sy = 0, down = false, moved = false, swipedAt = 0;

    // One permanent guard instead of arming a listener per swipe. The old code
    // added a one-shot click-swallower after every swipe and only unhooked it
    // when a click arrived — but a touch swipe usually produces no synthetic
    // click, so it stayed armed and ate the shopper's next real tap (first tap
    // after changing an image did nothing; they had to tap twice to open the
    // PDP). A timestamp cannot leak: clicks within 400ms of a swipe are the
    // browser's synthetic one and get blocked, everything later passes through.
    var clickHost = root.closest('a') || root;
    clickHost.addEventListener('click', function (ev) {
      if (Date.now() - swipedAt < 400) { ev.preventDefault(); ev.stopPropagation(); }
    }, true);
    track.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.gy-qk, [data-gy-cardimg-prev], [data-gy-cardimg-next]')) return;
      down = true; moved = false; sx = e.clientX; sy = e.clientY;
    });
    // a vertical scroll cancels the pointer sequence — clear state so it can't wedge
    window.addEventListener('pointercancel', function () { down = false; });
    window.addEventListener('pointerup', function (e) {
      if (!down) return; down = false;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > SWIPE && Math.abs(dx) > Math.abs(dy)) {
        moved = true;
        go(dx < 0 ? cur + 1 : cur - 1);
        // mark the swipe; the guard above blocks only the click it may produce
        swipedAt = Date.now();
        setTimeout(function () { moved = false; }, 60);
      }
    });

    root.setAttribute('data-gy-cardimg-ready', '');
  }
  function initAll(ctx) {
    (ctx || document).querySelectorAll('[data-gy-cardimg]:not([data-gy-cardimg-ready])').forEach(wire);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  // exposed so JS-populated card lists (e.g. PDP "keep exploring") can init later
  window.gyCardImgInit = initAll;
})();
